export default {
  connectedUser: {
    displayName: '',
    email: '',
    creationTime: '',
    lastSignInTime: '',
    photoUrl: '',
    uid: ''
  },
  spaces: [],
  selectedSpace: '',
  unsubscribeSpaces: null,
  tickets: [],
  unsubscribeTickets: null,
  startAnimationOver: false
};
